import styled from 'styled-components';
import onlyRunInDev from '../../../utils/onlyRunInDev';
var missingThemeStyles = onlyRunInDev(function (theme, themeKey) {
  if (!theme) {
    // eslint-disable-next-line
    console.warn('A themeable component was used without a theme. ' + 'Please ensure that you have correctly added a theme to your application. ' + 'More info here: https://styled-components.com/docs/advanced#theming');
    return true;
  }

  if (!(theme == null ? void 0 : theme[themeKey])) {
    console.warn("No theme styles found for " + themeKey); // eslint-disable-line

    return true;
  }

  return false;
});
/**
 * Creates a component that can automatically pull styles from a properly formatted styled components theme file. See the docs on theming for how to set up a theme properly to take full advantage of components created with createThemedComponent.
 *
 * All themed components take highest specificity precedence. Any styling that wishes to overrride theming from createThemedComponent should use be wrapped in `&&& { }`.
 *
 * See https://internal.minerva.dev/pantheon/?path=/story/theming-themingguide--theming-guide for more details on how to use theming.
 *
 *```js
 * import { createThemedComponent, Footer as PantheonFooter } from '@minerva-analytics/pantheon';
 *
 * const Footer = createThemedComponent('Footer', PantheonFooter);
 *```
 *
 * @param {string} themeKey - The key in the theme that styles are pulled from
 * @param {(string|Component)} item - The type of component to create. Pass a
 *    string for basic html elements (eg. `button`) or a React component for more
 *    complex cases.
 *
 * @returns {Component} - A new themeable component
 */

var createThemedComponent = function createThemedComponent(themeKey, item) {
  var getThemeStyles = function getThemeStyles(props) {
    return missingThemeStyles(props.theme, themeKey) ? '' : props.theme[themeKey];
  };

  return styled(item).withConfig({
    displayName: "createThemedComponent",
    componentId: "pantheon__sc-1xokks8-0"
  })(["&&{", "}"], function (props) {
    return getThemeStyles(props);
  });
};

export default createThemedComponent;